import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ImportProducts from '../ImportProducts';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import Sidebar from './Sidebar';
import { SIDEBAR_WIDTH } from './constants';

const Layout = ({ children }) => {
  const location = useLocation();
  const section = { '/licenses': 'license', '/certificates': 'certificate', '/domains': 'domain' }[location.pathname]
    || (/^\/assets\/category\/(physical|token)$/.exec(location.pathname)?.[1]);
  const subcategory = new URLSearchParams(location.search).get('subcategory') || '';
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen((prev) => !prev);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
      <Sidebar open={sidebarOpen} onClose={handleSidebarClose} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
          minHeight: '100vh',
          px: { xs: 1.5, sm: 2, md: 3 },
          py: { xs: 1.5, sm: 2.5 },
        }}
      >
        {isMobile && <Box sx={{ mb: 2 }}><Button onClick={handleSidebarToggle} startIcon={<MenuIcon />}>Menu</Button></Box>}
        <Box
          sx={{
            minHeight: 'calc(100vh - 24px)',
            borderRadius: 0,
            backgroundColor: 'background.default',
          }}
        >
          {section && <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}><ImportProducts section={section} subcategory={subcategory} /></Box>}
          {children}
        </Box>
      </Box>

      {isMobile && sidebarOpen && (
        <Box
          onClick={handleSidebarClose}
          sx={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(15, 23, 42, 0.35)',
            zIndex: theme.zIndex.drawer - 1,
          }}
        />
      )}
    </Box>
  );
};

export default Layout;
